// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2tAvV","title":"Info_title__1PmnF","links":"Info_links__1DKNw","link":"Info_link__2Z9XX","logo":"Info_logo__3d0pr"};